import { combineReducers } from 'redux';
import singleOrderReducer from './SingleOrder/singleOrderSlice';
import createOrderReducer from './CreateOrder/createOrderSlice';

export default combineReducers({
  singleOrder: singleOrderReducer,
  createOrder: createOrderReducer,
});
